export default __webpack_public_path__ + "static/web20230627-48bc3fad705fb0a1ebc94624567a3681.png";